import React from 'react';

const Australia = (props: { width: number }) => {
  return (
    <svg viewBox="0 0 10080 5040" {...props}>
      <title>Australian Flag</title>
      <defs>
        <clipPath id="australia-b">
          <path d="M0 0v1.5h7V3H6zm6 0H3v3.5H0V3z" />
        </clipPath>
        <path
          d="M0-360l69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z"
          id="australia-a"
        />
        <path
          d="M0-210L54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z"
          id="australia-d"
        />
        <use id="australia-c" transform="scale(2.1)" xlinkHref="#australia-a" />
      </defs>
      <path d="M0 0h10080v5040H0z" fill="#00008b" />
      <path d="M0 0l5040 2520m0-2520L0 2520" stroke="#fff" strokeWidth="504" />
      <path
        clipPath="url(#australia-b)"
        d="M0 0l6 3m0-3L0 3"
        stroke="red"
        strokeWidth=".4"
        transform="scale(840)"
      />
      <path d="M2520 0v2940M0 1260h5880" stroke="#fff" strokeWidth="840" />
      <path d="M2520 0v2940M0 1260h5880" stroke="red" strokeWidth="504" />
      <path d="M0 2520h5040V0h1680v3360H0z" fill="#00008b" />
      <g fill="#fff">
        <use x="2520" xlinkHref="#australia-c" y="3780" />
        <use x="7560" xlinkHref="#australia-a" y="4200" />
        <use x="6300" xlinkHref="#australia-a" y="2205" />
        <use x="7560" xlinkHref="#australia-a" y="840" />
        <use x="8680" xlinkHref="#australia-a" y="1869" />
        <use x="8064" xlinkHref="#australia-d" y="2730" />
      </g>
    </svg>
  );
};

export default Australia;
